import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Loading, Pagetitle } from '@ktag/styleguide/dist/react';
import { useMutation } from '@tanstack/react-query';
import { useParams, useSearchParams } from 'react-router-dom';
import AppContext from 'AppContext';
import DataPolicy from 'components/dataPolicy/DataPolicy';
import UnsubscribeConfirmation from './UnsubscribeConfirmation';

const Unsubscribe = () => {
  const { t } = useTranslation('newsletter');
  const [isUnsubscriptionDecisionView, setIsUnsubscriptionDecisionView] = useState(true);
  const [doNotUnsubscribe, setDoNotUnsubscribe] = useState(false);
  const { cancellationApi } = useContext(AppContext);
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();

  const requestCancellation = useMutation<void, void, [number, string]>({
    mutationFn: ([listId, hash]) => cancellationApi.directCancellation(listId, hash),
  });

  const handleUnsubscribeConfirmClick = async () => {
    requestCancellation.mutate([Number(id), searchParams.get('hash')]);
    setIsUnsubscriptionDecisionView(false);
  };

  const handleUnsubscribeDeclineClick = () => {
    setDoNotUnsubscribe(true);
    setIsUnsubscriptionDecisionView(false);
  };

  if (isUnsubscriptionDecisionView) {
    return (
      <>
        <Pagetitle additionalClassNames="unsubscribe__header">
          {t('unsubscribe_header')}
        </Pagetitle>
        <p>{t('unsubscribe_decision_text')}</p>
        <div className="unsubscribe__decision-container">
          <Button onClick={handleUnsubscribeConfirmClick} primary>
            {t('unsubscribe_yes')}
          </Button>
          <Button onClick={handleUnsubscribeDeclineClick}>{t('unsubscribe_no')}</Button>
        </div>
        <DataPolicy />
      </>
    );
  }

  if (requestCancellation.isLoading && !isUnsubscriptionDecisionView) {
    return <Loading size="medium" />;
  }

  return (
    <UnsubscribeConfirmation
      viaNewsletter
      newsletterId={Number(id)}
      doNotUnsubscribe={doNotUnsubscribe}
      isSuccessful={requestCancellation.isSuccess}
    />
  );
};

export default Unsubscribe;
